import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useUnleashHook from '../../core/unleash/useUnleashHook';
import UnleashService from '../../services/unleash/unleash.service';
import { fetchLearningPlans } from './services/learning-plan.service';
import { INITIAL_PAGE_SIZE, DEFAULT_COLUMNS } from './constants/learning-plans-constants';
import { formatLastRefreshedTime } from './utils/learning-plans.utils';


const useLearningPlansHook = (classes) => {
  const navigate = useNavigate();
  const shouldShowLearningPlans = useUnleashHook(UnleashService.FLAGS.SHOW_LEARNING_PLAN_IN_ADMIN).isFlagEnabled();

  const [learningPlanState, setLearningPlanState] = useState({
    learningPlans: [], 
    loading: true, 
    error: null, 
    lastRefreshed: null, 
    pageSize: INITIAL_PAGE_SIZE 
  });

  const handleDetailsClick = (plan) => {
    if(!plan || !plan?.key) return;
    navigate(`/learning-plans/${plan.key}`, { state: { plan } });
  };

  const handleGamificationClick = (plan) => {
    console.log('Gamification clicked for learning plan:', plan);
  };

  const handleViewProgressClick = (plan) => {
    if(!plan || !plan?.key) return;
    navigate(`/learning-plans/${plan.key}/progress`, { state: { plan } });
  };

  const getLearningPlans = async () => {
    try {
      setLearningPlanState(prev => ({ ...prev, loading: true }));

      const actions = {
        handleDetailsClick,
        handleGamificationClick,
        handleViewProgressClick
      };

      const transformedLearningPlans = await fetchLearningPlans(actions, classes);
      
      setLearningPlanState(prev => ({
        ...prev,
        learningPlans: transformedLearningPlans,
        lastRefreshed: new Date(),
        loading: false
      }));
    } catch (err) {
      console.error(err);
      
      setLearningPlanState(prev => ({
        ...prev,
        error: 'Failed to fetch learning plans',
        learningPlans: [],
        loading: false
      }));
    }
  };

  useEffect(() => {
    if (shouldShowLearningPlans) {
      getLearningPlans();
    }
  }, [shouldShowLearningPlans]);

  return {
    learningPlans: learningPlanState.learningPlans,
    loading: learningPlanState.loading,
    error: learningPlanState.error,
    lastRefreshed: learningPlanState.lastRefreshed,
    pageSize: learningPlanState.pageSize,
    refreshLearningPlans: getLearningPlans,
    formatLastRefreshedTime,
    columns: DEFAULT_COLUMNS,
    shouldShowLearningPlans
  };
};

export default useLearningPlansHook;

